import React from "react";
import BackgroundContainer from "../../../components/BackgroundContainer/BackgroundContainer";
import Feedback from "../../../components/Feedback";

function Invalido() {
  return (
    <BackgroundContainer>
      <main style={{ width: "100vw", height: "100vh" }}>
        <Feedback
          title="Formulário não existente!"
          text="O formulário que você está tentando responder não existe. Isso provavelmente é algum erro com o link utilizado. Fale com nossa equipe."
        />
      </main>
    </BackgroundContainer>
  );
}

export default Invalido;
